import { GetBannerResponse } from '@aaa-ncnu-ie/mypolicy-api-banner';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import axios from './axios';

export const getBanner = async (riskStateList: string) => {
  if (!riskStateList) {
    return Promise.reject(new Error('Missing required parameter'));
  }
  const { data } = await axios.get<GetBannerResponse>(
    `${import.meta.env.VITE_BANNER_API_URL}/v1/banner`,
    {
      params: {
        riskStates: riskStateList,
      },
    }
  );

  return data;
};

export const useBannerQuery = (riskStateList: string, disable?: boolean) =>
  useQuery({
    queryKey: ['banner', riskStateList],
    queryFn: () => getBanner(riskStateList),
    // 30 minute cache time... hopefully not too extreme
    staleTime: 1000 * 60 * 30,
    enabled: !disable,
  });
